import React, { FC } from 'react';
import ViewBase from 'src/components/ViewBase';
import Content from './view/Content';
import HeaderContent from './view/HeaderContent';
import { Typography } from '@mui/material';

const Inbox: FC = () => {
  const Title = <Typography>תיבות דואר</Typography>;

  return (
    <ViewBase Title={Title} HeaderContent={<HeaderContent />}>
      <Content />
    </ViewBase>
  );
};

export default Inbox;
